import { render, staticRenderFns } from "./LimitsTableRow.vue?vue&type=template&id=df9a529e"
import script from "./LimitsTableRow.vue?vue&type=script&lang=js"
export * from "./LimitsTableRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports